export function hasMarketingConsent(cookiesValue: string): boolean {
  if (!cookiesValue) {
    return false;
  }
  const decoded = decodeURIComponent(cookiesValue);
  const split = decoded.split('@');
  const consentItems = split[2]?.split(',');

  return consentItems?.includes('2');
}
